import urlApi from "./urlApi";
export var CREATE_PREFIX_REQUEST = 'CREATE_PREFIX_REQUEST';
export var CREATE_PREFIX_SUCCESS = 'CREATE_PREFIX_SUCCESS';
export var CREATE_PREFIX_ERROR = 'CREATE_PREFIX_ERROR';
export function createPrefix(areaId, countryId, userId) {
    return function (dispatch) {
        dispatch({
            type: CREATE_PREFIX_REQUEST,
        });
        return urlApi().createPrefix(areaId, countryId, userId).then(function (res) {
            dispatch({
                type: CREATE_PREFIX_SUCCESS,
                payload: res,
            });
        }).catch(function () {
            dispatch({
                type: CREATE_PREFIX_ERROR,
            });
        });
    };
}
export function addStepPrefix(areaId, countryId, userId) {
    return urlApi().addStepPrefix(areaId, countryId, userId)
        .then(function (res) { return res; })
        .catch(function (err) {
        console.error('addStepPrefix err', err);
    });
}
//# sourceMappingURL=createPrefix.js.mapimport urlApi from "./urlApi";
export var CREATE_PREFIX_REQUEST = 'CREATE_PREFIX_REQUEST';
export var CREATE_PREFIX_SUCCESS = 'CREATE_PREFIX_SUCCESS';
export var CREATE_PREFIX_ERROR = 'CREATE_PREFIX_ERROR';
export function createPrefix(areaId, countryId, userId) {
    return function (dispatch) {
        dispatch({
            type: CREATE_PREFIX_REQUEST,
        });
        return urlApi().createPrefix(areaId, countryId, userId).then(function (res) {
            dispatch({
                type: CREATE_PREFIX_SUCCESS,
                payload: res,
            });
        }).catch(function () {
            dispatch({
                type: CREATE_PREFIX_ERROR,
            });
        });
    };
}
export function addStepPrefix(areaId, countryId, userId) {
    return urlApi().addStepPrefix(areaId, countryId, userId)
        .then(function (res) { return res; })
        .catch(function (err) {
        console.error('addStepPrefix err', err);
    });
}
//# sourceMappingURL=createPrefix.js.map